import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'antd';
import '@ant-design/compatible/assets/index.css';

export default function CancelItem(props) {

    const [itemIdx, setItemIdx] = useState(null)

    useEffect(() => {
        setItemIdx(props.currentTableItemIdx);
    }, [props.currentTableItem])

    const doRemoveitem = () => {
        props.remove('item', props.currentTableItem, itemIdx)
        props.close()
    }

    return (
        <Row gutter={24} className='contentSelectClientInputs' style={{marginTop: '50px'}}>
            <Col span={24} className='textCenter' style={{lineHeight:'25px', marginBottom:'15px'}}>Deseja realmente cancelar o item "{props.currentTableItem.name}"?</Col>
            <Col span={12}>
                <Button onClick={doRemoveitem} type="primary" className='fullWidth'>Confirmar</Button>
            </Col>
            <Col span={12}>
                <Button onClick={props.close} type="danger" className='fullWidth'>Cancelar</Button>
            </Col>
        </Row>
    )
}